<template lang="pug">
.wrapper-documentation(:class="'wrapper-documentation-'+context")
  include DashboardDocuments.pug
</template>

<script type="text/javascript">
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: "DashboardDocuments",
  components: {
  },
  computed: mapState([
    "token", "context",
  ]),
  data() {
    return {
      name: "",
      user: null,
      documents: [],
      redirectTo: null,
      remoteForm: {
        action: null,
      },
    }
  },
  created() {
    const _this = this;
    const currentAddress = `${window.location.href}`
    this.redirectTo = currentAddress

    this.remoteForm.action = Api.getApiUrl() + "/esreps/add-documentation/";

    Api.me(this.$store.state.token).then(result => {
      _this.user = result.data;
      _this.documents = result.data.documents
    }).catch(err => {
      // TODO: Manage error
    });
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "Dashboard";
@import "DashboardResources";
@import "DashboardDocuments";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardDocuments.vue